import { useMutation } from "@tanstack/react-query";

import ky from "@/shared/api";
import dom from "@/shared/helper/dom.helper.ts";

export function usePackageQrDocuments() {
  return useMutation<Blob, void, { count: number }>({
    mutationFn: ({ count }) =>
      ky
        .post("/api/v1/order/identification/links", {
          json: { count },
          timeout: 60 * 1000,
        })
        .blob(),
    onSuccess: (blob) => {
      dom.saveTxtFileFromBase64("Выгрузка QR для пакетов", blob);
    },
  });
}
